import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  RecoilRoot
} from 'recoil';
import axios from 'axios';
import {
  BrowserRouter as Router,
} from "react-router-dom";

axios.defaults.baseURL = 'https://twurs-tech-shop.herokuapp.com'
// axios.defaults.baseURL = 'http://localhost:5000'


ReactDOM.render(
  <React.StrictMode>
    <Router>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
